// src/components/Navbar.js
import React, { useState } from "react";
import "../styles/Navbar.css";
import { FiMenu, FiX, FiFileText } from "react-icons/fi";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.gif";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = isOpen ? "auto" : "hidden"; // Prevent scroll
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <div className="hamburger" onClick={toggleMenu}>
            {isOpen ? <FiX size={26} /> : <FiMenu size={26} />}
          </div>
          {/* <div className="logo">Phetolo<span className="dot">Software</span></div> */}
          <div className="logo-section">
            <Link to="/" className="logo-link">
              <img src={logo} alt="Ulterspace Logo" className="logo-image" />
              <div className="brand-text">
                <h1 className="brand-name">ULTERSPACE</h1>
                <p className="slogan">Technological Innovation</p>
              </div>
            </Link>
          </div>
        </div>
        <div className="navbar-right">
          <a href="/Ulterspace.pdf" download title="Download ">
            <FiFileText size={22} color="#0c7fb9ff" />
          </a>
        </div>
        <ul className="nav-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/Services">Services</Link>
          </li>
          <li>
            <Link to="/Packages">Packages</Link>
          </li>
          <li>
            <Link to="/About">About</Link>
          </li>
          <li>
            <Link to="/Blog">Blog</Link>
          </li>
          <li>
            <Link to="/Contact">Contact</Link>
          </li>
          <div className="desktop-icons">
            <a href="/Ulterspace.pdf" download title="Download ">
              <FiFileText size={22} color="#0c7fb9ff" className="icon" />
            </a>
          </div>
        </ul>
      </nav>

      {isOpen && <Sidebar closeMenu={toggleMenu} />}
    </>
  );
};

export default Navbar;
